var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "기계분야_종합 목록",
                columns: _vm.grid.columns,
                merge: _vm.grid.merge,
                gridHeight: _vm.grid.height,
                data: _vm.focus.hazardFocusInspItemCommonModelList,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                noDataLabel: "항목별 결과 추가하세요.",
                hideBottom: true,
                editable: _vm.editable && !_vm.disabled,
                rowKey: "focusInspectionItemId",
              },
              on: { "table-data-change": _vm.tableChange },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      props.row["sopImprovementIds"] &&
                      props.row["ibmStepNames"] &&
                      col.name === "customCol"
                        ? _vm._l(
                            _vm.$comm.ibmTagItems(props.row, _vm.colorItems),
                            function (item, index) {
                              return _c(
                                "q-chip",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-bottom": "4px !important",
                                  },
                                  attrs: {
                                    color: item.color,
                                    clickable: true,
                                    "text-color": "white",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.linkClick(item, props.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(" " + _vm._s(item.title) + " "),
                                  _c("c-assess-tooltip", {
                                    attrs: {
                                      ibmTooltip: item.ibmTooltip,
                                      ibmClassCd: item.ibmClassCd,
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          )
                        : _vm._e(),
                      _vm.editable &&
                      col.name === "customCol" &&
                      Boolean(props.row.focusInspectionItemId) &&
                      props.row.editFlag !== "C" &&
                      !_vm.disabled
                        ? _c(
                            "div",
                            [
                              _c(
                                "q-btn-group",
                                {
                                  staticClass: "ColumInnerBtnGroup",
                                  attrs: { outline: "" },
                                },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      staticClass: "ColumInnerBtn",
                                      attrs: {
                                        icon: "add",
                                        color: "red-6",
                                        "text-color": "white",
                                        align: "center",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.innerBtnClicked(
                                            col,
                                            props,
                                            "1"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(" 개선요청등록 "),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-btn",
                                    {
                                      staticClass: "ColumInnerBtn",
                                      attrs: {
                                        icon: "add",
                                        color: "light-blue",
                                        "text-color": "white",
                                        align: "center",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.innerBtnClicked(
                                            col,
                                            props,
                                            "2"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(" 즉시조치등록 "),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : col.name === "customCol2" &&
                          _vm.focus.hazardFocusInspEquipModelList.length > 0 &&
                          props.row["checkItemValue"] === "HIV0000003"
                        ? [
                            _c("c-tag", {
                              attrs: {
                                editable: _vm.editable && !_vm.disabled,
                                icon: "build",
                                itemText: "machineryName",
                                itemValue: "check",
                                name: "hazardFocusInspItemEquipModelList",
                              },
                              on: {
                                addTag: function ($event) {
                                  return _vm.add(props.row)
                                },
                                removeTag: (item) =>
                                  _vm.remove(item, props.row),
                              },
                              model: {
                                value:
                                  props.row.hazardFocusInspItemEquipModelList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    props.row,
                                    "hazardFocusInspItemEquipModelList",
                                    $$v
                                  )
                                },
                                expression:
                                  "props.row.hazardFocusInspItemEquipModelList",
                              },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "suffixTitle" },
                [
                  !_vm.focus.hazardFocusInspEquipModelList ||
                  _vm.focus.hazardFocusInspEquipModelList.length === 0
                    ? _c("font", { attrs: { color: "#C10015" } }, [
                        _vm._v(
                          " ※ 점검관련대상 탭에서 유해위험기계기구를 추가하세요. "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }